import React from 'react'
import { GLBModel } from '../../GLBModel'
import type { DecorationsProps } from '../types'

export const Decorations: React.FC<DecorationsProps> = ({ height, onBackgroundClick }) => (
  <GLBModel
    modelUrl="/cdn/assets/3d-models/waze-flowers.glb"
    useDraco
    modelPosition={[-10, height, 33]}
    modelScale={[2.0, 2.0, 2.0]}
    shouldCastShadow
    shouldReceiveShadow
    onClick={onBackgroundClick}
    userData={{ isWazeWithFlowers: true }}
  />
)
